/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * RapidWorks.UserManagement.WebApi | v1
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type { GetApiUserManagementV1AuditLogExportParams, GetApiUserManagementV1AuditLogParams, ProblemDetails } from '../model';

import { axiosInstance } from '../../axios-instance.ts';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key]
    });
  }
  return result;
};

export const getApiUserManagementV1AuditLog = (
  params?: GetApiUserManagementV1AuditLogParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>({ url: `/api/user-management/v1/audit-log`, method: 'GET', params, signal }, options);
};

export const getGetApiUserManagementV1AuditLogQueryKey = (params?: GetApiUserManagementV1AuditLogParams) => {
  return [`/api/user-management/v1/audit-log`, ...(params ? [params] : [])] as const;
};

export const getGetApiUserManagementV1AuditLogQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUserManagementV1AuditLog>>,
  TError = unknown
>(
  params?: GetApiUserManagementV1AuditLogParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1AuditLog>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUserManagementV1AuditLogQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUserManagementV1AuditLog>>> = ({ signal }) =>
    getApiUserManagementV1AuditLog(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUserManagementV1AuditLog>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUserManagementV1AuditLogQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUserManagementV1AuditLog>>>;
export type GetApiUserManagementV1AuditLogQueryError = unknown;

export function useGetApiUserManagementV1AuditLog<TData = Awaited<ReturnType<typeof getApiUserManagementV1AuditLog>>, TError = unknown>(
  params: undefined | GetApiUserManagementV1AuditLogParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1AuditLog>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1AuditLog>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1AuditLog>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1AuditLog<TData = Awaited<ReturnType<typeof getApiUserManagementV1AuditLog>>, TError = unknown>(
  params?: GetApiUserManagementV1AuditLogParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1AuditLog>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1AuditLog>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1AuditLog>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1AuditLog<TData = Awaited<ReturnType<typeof getApiUserManagementV1AuditLog>>, TError = unknown>(
  params?: GetApiUserManagementV1AuditLogParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1AuditLog>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiUserManagementV1AuditLog<TData = Awaited<ReturnType<typeof getApiUserManagementV1AuditLog>>, TError = unknown>(
  params?: GetApiUserManagementV1AuditLogParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1AuditLog>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUserManagementV1AuditLogQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getApiUserManagementV1AuditLogExport = (
  params?: GetApiUserManagementV1AuditLogExportParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>({ url: `/api/user-management/v1/audit-log/export`, method: 'GET', params, signal }, options);
};

export const getGetApiUserManagementV1AuditLogExportQueryKey = (params?: GetApiUserManagementV1AuditLogExportParams) => {
  return [`/api/user-management/v1/audit-log/export`, ...(params ? [params] : [])] as const;
};

export const getGetApiUserManagementV1AuditLogExportQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUserManagementV1AuditLogExport>>,
  TError = unknown
>(
  params?: GetApiUserManagementV1AuditLogExportParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1AuditLogExport>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUserManagementV1AuditLogExportQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUserManagementV1AuditLogExport>>> = ({ signal }) =>
    getApiUserManagementV1AuditLogExport(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUserManagementV1AuditLogExport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUserManagementV1AuditLogExportQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUserManagementV1AuditLogExport>>>;
export type GetApiUserManagementV1AuditLogExportQueryError = unknown;

export function useGetApiUserManagementV1AuditLogExport<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1AuditLogExport>>,
  TError = unknown
>(
  params: undefined | GetApiUserManagementV1AuditLogExportParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1AuditLogExport>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1AuditLogExport>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1AuditLogExport>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1AuditLogExport<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1AuditLogExport>>,
  TError = unknown
>(
  params?: GetApiUserManagementV1AuditLogExportParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1AuditLogExport>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1AuditLogExport>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1AuditLogExport>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1AuditLogExport<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1AuditLogExport>>,
  TError = unknown
>(
  params?: GetApiUserManagementV1AuditLogExportParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1AuditLogExport>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiUserManagementV1AuditLogExport<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1AuditLogExport>>,
  TError = unknown
>(
  params?: GetApiUserManagementV1AuditLogExportParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1AuditLogExport>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUserManagementV1AuditLogExportQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getApiUserManagementV1AuditLogEntryId = (
  entryId: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>({ url: `/api/user-management/v1/audit-log/${entryId}`, method: 'GET', signal }, options);
};

export const getGetApiUserManagementV1AuditLogEntryIdQueryKey = (entryId: number) => {
  return [`/api/user-management/v1/audit-log/${entryId}`] as const;
};

export const getGetApiUserManagementV1AuditLogEntryIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUserManagementV1AuditLogEntryId>>,
  TError = unknown
>(
  entryId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1AuditLogEntryId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUserManagementV1AuditLogEntryIdQueryKey(entryId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUserManagementV1AuditLogEntryId>>> = ({ signal }) =>
    getApiUserManagementV1AuditLogEntryId(entryId, requestOptions, signal);

  return { queryKey, queryFn, enabled: entryId !== null && entryId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUserManagementV1AuditLogEntryId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUserManagementV1AuditLogEntryIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiUserManagementV1AuditLogEntryId>>
>;
export type GetApiUserManagementV1AuditLogEntryIdQueryError = unknown;

export function useGetApiUserManagementV1AuditLogEntryId<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1AuditLogEntryId>>,
  TError = unknown
>(
  entryId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1AuditLogEntryId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1AuditLogEntryId>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1AuditLogEntryId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1AuditLogEntryId<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1AuditLogEntryId>>,
  TError = unknown
>(
  entryId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1AuditLogEntryId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1AuditLogEntryId>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1AuditLogEntryId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1AuditLogEntryId<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1AuditLogEntryId>>,
  TError = unknown
>(
  entryId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1AuditLogEntryId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiUserManagementV1AuditLogEntryId<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1AuditLogEntryId>>,
  TError = unknown
>(
  entryId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1AuditLogEntryId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUserManagementV1AuditLogEntryIdQueryOptions(entryId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const postApiUserManagementV1AuditLogEntryIdReview = (
  entryId: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>({ url: `/api/user-management/v1/audit-log/${entryId}/review`, method: 'POST', signal }, options);
};

export const getPostApiUserManagementV1AuditLogEntryIdReviewMutationOptions = <TError = ProblemDetails, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUserManagementV1AuditLogEntryIdReview>>,
    TError,
    { entryId: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof postApiUserManagementV1AuditLogEntryIdReview>>, TError, { entryId: number }, TContext> => {
  const mutationKey = ['postApiUserManagementV1AuditLogEntryIdReview'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiUserManagementV1AuditLogEntryIdReview>>, { entryId: number }> = (
    props
  ) => {
    const { entryId } = props ?? {};

    return postApiUserManagementV1AuditLogEntryIdReview(entryId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUserManagementV1AuditLogEntryIdReviewMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiUserManagementV1AuditLogEntryIdReview>>
>;

export type PostApiUserManagementV1AuditLogEntryIdReviewMutationError = ProblemDetails;

export const usePostApiUserManagementV1AuditLogEntryIdReview = <TError = ProblemDetails, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiUserManagementV1AuditLogEntryIdReview>>,
      TError,
      { entryId: number },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof postApiUserManagementV1AuditLogEntryIdReview>>, TError, { entryId: number }, TContext> => {
  return useMutation(getPostApiUserManagementV1AuditLogEntryIdReviewMutationOptions(options), queryClient);
};
